import { Link } from "react-router-dom";
import { Calculator, Gauge, ArrowLeftRight, GitCompareArrows, Percent, FileCheck2, HeartPulse, ArrowRight } from "lucide-react";
import SectionHead from "../components/site/SectionHead";

const TOOLS = [
  { icon: Calculator, title: "EMI Calculator", desc: "Estimate monthly EMI, total interest and total payable for any loan.", to: "/calculators/emi", live: true },
  { icon: Gauge, title: "Loan Eligibility Calculator", desc: "Get an indicative eligibility estimate based on your income and obligations.", to: "/calculators/eligibility", live: true },
  { icon: GitCompareArrows, title: "Loan Comparison", desc: "Compare loan products side by side — rates, fees, tenure and eligibility.", to: "/compare-loans", live: true },
  { icon: ArrowLeftRight, title: "Balance Transfer Savings", desc: "Estimate potential savings when moving an existing loan to a new lender.", to: "", live: false },
  { icon: Percent, title: "Interest Rate Comparison", desc: "Compare indicative rate ranges across products and lender categories.", to: "", live: false },
  { icon: FileCheck2, title: "Document Checklist", desc: "A personalized document checklist based on your product and profile.", to: "", live: false },
  { icon: HeartPulse, title: "Financial Health Tool", desc: "Assess your debt-to-income posture and borrowing readiness.", to: "", live: false },
];

export default function Calculators() {
  return (
    <div data-testid="calculators-page" className="container-site py-14 lg:py-20">
      <SectionHead eyebrow="Financial Tools" title="Calculators & Decision Tools"
        subtitle="Free tools to help you plan, compare and decide. Estimates are indicative; final terms are set by the lending partner." />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
        {TOOLS.map((t, i) =>
          t.live ? (
            <Link key={i} to={t.to} data-testid={`tool-${t.title.toLowerCase().replace(/\s+/g, "-")}`} className="card-site group p-7 flex flex-col">
              <span className="w-12 h-12 rounded-2xl bg-brand-red/5 text-brand-red flex items-center justify-center transition-colors duration-300 group-hover:bg-brand-red group-hover:text-white"><t.icon size={22} /></span>
              <h3 className="mt-5 font-heading text-lg font-bold text-brand-dark">{t.title}</h3>
              <p className="mt-2 text-sm text-brand-muted leading-relaxed flex-1">{t.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-brand-red">Open Tool <ArrowRight size={14} /></span>
            </Link>
          ) : (
            <div key={i} data-testid={`tool-coming-${i}`} className="card-site p-7 flex flex-col opacity-60">
              <span className="w-12 h-12 rounded-2xl bg-black/5 text-brand-muted flex items-center justify-center"><t.icon size={22} /></span>
              <h3 className="mt-5 font-heading text-lg font-bold text-brand-dark">{t.title}</h3>
              <p className="mt-2 text-sm text-brand-muted leading-relaxed flex-1">{t.desc}</p>
              <span className="mt-4 text-xs font-bold uppercase tracking-[0.15em] text-brand-gold">Coming Soon</span>
            </div>
          )
        )}
      </div>
    </div>
  );
}
